import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import SeparatorPage, {
  SeparatorPageTab,
} from "pages/app/separator/SeparatorPage";
import { getSeparator } from "api/separator.api";

const separatorSearchSchema = z.object({
  tab: z
    .nativeEnum(SeparatorPageTab)
    .optional()
    .catch(SeparatorPageTab.Overview),
});

export const Route = createFileRoute(
  "/_authenticated/app/kunder/$customerId/facility/$facilityId/separator/$separatorId",
)({
  validateSearch: separatorSearchSchema,
  beforeLoad: async ({ context: { queryClient }, params }) => {
    await queryClient.ensureQueryData(getSeparator(Number(params.separatorId)));
  },
  component: SeparatorPage,
});
